var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2C17.5523 2 18 2.44772 18 3V7H16V3C16 2.44772 16.4477 2 17 2Z",
    fill: "#0A51C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3V15H8V3Z",
    fill: "#0A51C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17H6V21C6 21.5523 6.44772 22 7 22C7.55228 22 8 21.5523 8 21V17Z",
    fill: "#0A51C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H16V21C16 21.5523 16.4477 22 17 22C17.5523 22 18 21.5523 18 21V9Z",
    fill: "#0A51C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16C10 14.3431 8.65685 13 7 13C5.34315 13 4 14.3431 4 16C4 17.6569 5.34315 19 7 19C8.65685 19 10 17.6569 10 16ZM8 16C8 15.4477 7.55228 15 7 15C6.44772 15 6 15.4477 6 16C6 16.5523 6.44772 17 7 17C7.55228 17 8 16.5523 8 16Z",
    fill: "#0A51C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8C20 6.34315 18.6569 5 17 5C15.3431 5 14 6.34315 14 8C14 9.65685 15.3431 11 17 11C18.6569 11 20 9.65685 20 8ZM18 8C18 7.44772 17.5523 7 17 7C16.4477 7 16 7.44772 16 8C16 8.55228 16.4477 9 17 9C17.5523 9 18 8.55228 18 8Z",
    fill: "#0A51C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.a68ce2bfc148ef3407a94c1b1399ceef.svg";
export { ForwardRef as ReactComponent };